import { ComponentAccordion } from "types/CMS/KontentAI/content-types";
import { assetResolver } from "./asset";
import { CtaResolver } from "./cta";
import { accordion } from "types/CMS/Unum/accordion";
import { richTextResolver } from "./richText";
import { getUuid } from "utils/util";
import { createResolver } from "./Factories/ResolverFactory";
import { productTaxonomyResolver } from "./products";

export const accordionResolver = createResolver({
  resolve: (accordion: ComponentAccordion): accordion => {
    return {
      isFilterable: true,
      productTaxonomy: productTaxonomyResolver.resolve(
        accordion.elements.products
      ).result,
      key: getUuid(),
      type: "accordion",
      title: accordion.elements.title.value,
      subtitle: accordion.elements.subtitle.value,
      body: richTextResolver.resolve(accordion.elements.body).result,
      asset: assetResolver.resolve(accordion.elements.asset.linkedItems[0])
        .result,
      cta: CtaResolver.resolve(accordion.elements.ctas.linkedItems).result,
    };
  },
});

